export default __webpack_public_path__ + "static/media/payment-info-2x.4b4e0f3a.jpg";